import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Copy, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const UuidGeneratorTool = () => {
  const [uuids, setUuids] = useState([]);
  const [count, setCount] = useState(1);

  const generateUUID = () => {
    const newUuids = [];
    for (let i = 0; i < count; i++) {
      newUuids.push('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      }));
    }
    setUuids(newUuids);
  };

  const copyAll = () => {
    navigator.clipboard.writeText(uuids.join('\n'));
    toast.success('UUIDs copied!');
  };

  const copySingle = (uuid) => {
    navigator.clipboard.writeText(uuid);
    toast.success('UUID copied!');
  };

  return (
    <div className="space-y-6" data-testid="uuid-generator-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">UUID Generator</h3>
      </div>

      <div className="flex gap-2">
        <Input
          type="number"
          min={1}
          max={100}
          value={count}
          onChange={(e) => setCount(Math.min(100, Math.max(1, parseInt(e.target.value) || 1)))}
          className="w-24 bg-background/50"
          data-testid="count-input"
        />
        <Button onClick={generateUUID} className="flex-1" data-testid="generate-btn">
          <RefreshCw className="w-4 h-4 mr-2" />
          Generate UUID{count > 1 ? 's' : ''}
        </Button>
      </div>

      {uuids.length > 0 && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">{uuids.length} UUID{uuids.length > 1 ? 's' : ''} generated</span>
            <Button variant="ghost" size="sm" onClick={copyAll}>
              <Copy className="w-4 h-4 mr-1" /> Copy All
            </Button>
          </div>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {uuids.map((uuid, i) => (
              <div key={i} className="flex gap-2">
                <Input value={uuid} readOnly className="font-mono text-sm bg-background/50" />
                <Button variant="ghost" size="sm" onClick={() => copySingle(uuid)}>
                  <Copy className="w-4 h-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UuidGeneratorTool;
